import type { ReactNode } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { GlobalStyle } from "@vh/shared-ui";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";

// Guards a route: an anonymous session goes to the login screen. An unknown session (a reload with a
// stored role) is allowed through so the page can attempt its protected call and confirm or demote it.
function RequireAuth({ children }: { children: ReactNode }) {
	const { status } = useAuth();
	if (status === "anonymous") return <Navigate to="/login" replace />;
	return <>{children}</>;
}

export function App() {
	return (
		<AuthProvider>
			<GlobalStyle />
			<BrowserRouter>
				<Routes>
					<Route path="/login" element={<LoginPage />} />
					<Route
						path="/"
						element={
							<RequireAuth>
								<DashboardPage />
							</RequireAuth>
						}
					/>
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</BrowserRouter>
		</AuthProvider>
	);
}
